import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, Select, notification} from 'antd';

import {getFee, updateFee} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {getTaxGroups} from "../Tax/actions";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateFeeForm extends Component {
  componentDidMount() {
    const {dispensaryId, match: {params}} = this.props;
    const {feeId} = decodeParams(params);
    this.props.getTaxGroups({dispensaryId});
    this.props.getFee({feeId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {feeId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateFee({...values, feeId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, taxGroups, fee} = this.props;
    const {name, lineItemDescription, taxGroupId} = fee;
    return (
      <Card title="Update Fee">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Line item description"
            extra="This is what will be displayed on the cart/receipt"
          >
            {getFieldDecorator('lineItemDescription', {
              initialValue: lineItemDescription,
              rules: [{
                required: true,
                message: 'Line item description is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tax group"
          >
            {getFieldDecorator('taxGroupId', {
              initialValue: taxGroupId,
            })(
              <Select>
                <Option key="none" value={null}>NONE</Option>
                {taxGroups.map(({taxGroupId, name}) =>
                  <Option key={taxGroupId} value={taxGroupId}>{name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Fee
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateFeeForm.propTypes = {
  match: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string.isRequired,
  updateFee: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getTaxGroups: PropTypes.func.isRequired,
  taxGroups: PropTypes.array.isRequired,
  getFee: PropTypes.func.isRequired,
  fee: PropTypes.object.isRequired,
};

const UpdateFeePage = Form.create()(UpdateFeeForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.fee.feeLoading || state.fee.updatingFee,
  taxGroups: state.tax.taxGroups,
  fee: state.fee.fee || {},
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateFee,
  getTaxGroups,
  getFee,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateFeePage);



// WEBPACK FOOTER //
// ./src/Fee/UpdateFeePage.js